<template>
    <div class="history_list_box">
        <div style="display: flex; align-items: center">
          <el-select v-model="picFromInfo.devCode" clearable @change="devChange" style="width: 300px; margin-top: 10px; margin-right: 10px " collapse-tags placeholder="请选择设备">
            <el-option v-for="item in devOption" :key="item.code" :label="item.name" :value="item.code"> </el-option>
          </el-select>
          <HnDateSearch ref="dateSearch" :isPage="false" :defaultData="0" @update="dateUpdate" style="margin-top: 10px;" :timeList="[]" />
          <el-select v-model="picFromInfo.alarmType" clearable @change="alarmTypeChange" style="width: 200px; margin-top: 10px; margin-left: -4px " collapse-tags placeholder="请选择告警类型">
            <el-option v-for="item in alarmOption" :key="item.value" :label="item.value" :value="item.key"> </el-option>
          </el-select>
          <el-button  size="small" class="resetBut cp" @click="toReset" style="margin-top: 10px">清空</el-button>
        </div>

        <div class="table_box">
            <el-table :data="tableData" style="width: 100%" class="monitor-table" height="100%">
              <el-table-column prop="devCode" label="箱体编号" align="center"></el-table-column>
              <el-table-column prop="areaName" label="所属区域" align="center"></el-table-column>
              <el-table-column prop="alarmType" label="告警类型" align="center" :formatter="alarmTypeHanlde"></el-table-column>
              <el-table-column prop="alarmTime" label="告警时间" align="center"></el-table-column>
              <el-table-column prop="alarmContent" label="告警内容" align="center"></el-table-column>
<!--              <el-table-column prop="powerVoltage" label="负责人" align="center"></el-table-column>-->
<!--              <el-table-column prop="powerVoltage" label="联系方式" align="center"></el-table-column>-->
            </el-table>
        </div>
        <div class="pages_box" v-if="picTotal > 0">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="picFromInfo.pageIndex"
                :page-size="picFromInfo.pageSize" layout="total, prev, pager, next" class="pageInfo" background :total="picTotal">
              </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
          obj: {  // 修正 props 定义
            type: Object,
            default: () => ({})
          },
        },
      watch: {
        obj: {  // 修正 watch 监听
          handler(val) {
            if (val) {
              this.devOption = val.info
              this.picFromInfo.devCode = val.devSelect.code
            }
          },
          immediate: true,
          deep: true
        },
      },
        data(){
            return {
                date:[],
                picFromInfo:{
                    searchName: '',
                    devCode:'',
                    pageIndex:1,
                    pageSize:10,
                    beginAlarmDate: null,
                    endAlarmDate: null,
                    alarmType: null
                },
                picTotal:0,
                isPageShow:true,
                tableData: [],
                alarmOption: [],
                devOption: [],
            }
        },
        methods:{
            dateUpdate(data){
              console.log('zazazaza', data)
                Object.assign(this.picFromInfo,data)
                this.picFromInfo.beginAlarmDate = data.sTime
                this.picFromInfo.endAlarmDate = data.eTime

                this.getTableData();
            },
            handleCurrentChange(val) {
                this.picFromInfo.pageIndex = val;
                this.getTableData();
            },
            async getTableData() {
                const res = await this.$api.GetSmartGarbageRoomBoxAlarmPageList(this.picFromInfo)
                this.tableData = res ?.list || []
                this.picTotal = res ?.totalCount || 0;
            },
          alarmTypeHanlde(row) {
              let type = row.alarmType;
              return this.$formatter(type, 'alarmType')
            },
          async getAlarmOption() {
              await this.$api.GetSmartGarbageRoomBoxAlarmTypes().then((res) => {
                if (res){
                  this.alarmOption = res
                }
              })
          },
          alarmTypeChange(data) {
              this.picFromInfo.alarmType = data
              this.getTableData();
          },
          devChange(data) {
              this.picFromInfo.devCode = data
              this.getTableData();
          },
          toReset() {
            this.picFromInfo.alarmType = null
            this.picFromInfo.beginAlarmDate = ''
            this.picFromInfo.endAlarmDate = ''
            this.picFromInfo.searchName = null
            this.picFromInfo.devCode = null
            this.dateUpdate({sTime: '', eTime: '', timeType: null})
            this.$refs.dateSearch.timeChange()
            this.getTableData();
          },
        },
        mounted() {
            this.getTableData();
            this.getAlarmOption();
        }
    }
</script>

<style lang="scss" scoped>
.history_list_box{
    height: 550px;
    display: flex;
    flex-direction: column;
    .table_box{
        flex: 1;
        min-height: 0px;
        margin-top: 10px;
        ::v-deep .el-table--border{
            border: none !important;
        }
        ::v-deep .el-table {
            border: none !important;
        }

        ::v-deep .el-table::before {
            display: none !important;
            background-color: transparent !important;
        }
        ::v-deep .el-table--border::after{
            background-color: transparent !important;
        }
        .monitor-table {
            ::v-deep .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #2c3e50;
                        color: #ffffff;
                        border: none !important;
                    }
                }
            }

            ::v-deep .el-table__body-wrapper {
                .el-table__body {
                    td {
                        border: none !important;
                    }
                }
            }

            ::v-deep .el-table__border-line {
                display: none !important;
            }

            ::v-deep .el-table__body tr:hover > td {
                background-color: #34495e !important;
            }


        }
    }
    .pages_box {
        margin: 10px 0 ;
        text-align: right;
    }
}
::v-deep .el-input .el-input__inner{
  height: 36px;
}
.resetBut{
  color: #fff;
  border: 1px solid var(--el-color-primary);
  // background: var(--el-color-primary-light-2);
  margin-left: 10px;
}
</style>